import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const faqs = [
  {
    q: "What makes Danube properties unique?",
    a: "Danube Properties is known for creating modern, elegant developments with flexible payment plans, zero interest options, and prime locations. Their projects like Sparklz and TIMEZ offer contemporary lifestyle with over 30 amenities."
  },
  {
    q: "What are the payment plans for Danube properties?",
    a: "Danube offers attractive payment plans including 6 years payment plan with 1% monthly payment and 0% interest. They also provide post-handover payment plans and fully furnished apartment options."
  },
  {
    q: "What types of properties does Danube offer?",
    a: "Danube offers Studio, 1BR, 2BR & 3BR configurations with convertible apartments that can be transformed to meet evolving needs - studios to 1 BHKs and 1 BHKs to 2 BHKs."
  },
  {
    q: "What are the completion timelines?",
    a: "Both Sparklz and TIMEZ projects are scheduled for completion in Q2-2028, offering excellent investment opportunities with timely delivery."
  },
  {
    q: "What amenities are available?",
    a: "Danube properties feature over 30 lifestyle-enhancing amenities including central parks, metro access, shopping malls, and recreational facilities designed for modern urban living."
  },
  {
    q: "Why invest in Danube properties?",
    a: "Danube offers zero interest payment plans, high return on investment, prime locations, timely delivery, and modern amenities making it an excellent choice for both investors and end-users."
  }
];

export default function DanubePage() {
  return (
    <div className="flex flex-col min-h-screen font-sans bg-white">
      <Navbar />
      <main className="flex-1 pb-12 bg-white">
        {/* Hero Section */}
        <section className="relative w-full h-screen flex flex-col items-center justify-center bg-white">
          <img
            src="/Danube/Danube-Timez-Background-scaled-1.jpg"
            alt="Danube Properties Hero"
            className="absolute inset-0 w-full h-full object-cover z-0"
          />
          <div className="absolute inset-0 bg-black/40 z-0" />
          <div className="relative z-10 w-full flex flex-col items-center justify-center text-center">
            <h1 className="text-4xl md:text-5xl font-light mb-4 text-white font-serif drop-shadow-lg">Danube Properties</h1>
            <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">Modern Elegance Meets Contemporary Lifestyle</p>
          </div>
        </section>

        {/* Project Highlights Section */}
        <section className="max-w-6xl mx-auto py-20 px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" style={{fontFamily: 'Roboto, sans-serif'}}>Project Highlights</h2>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Sparklz Project */}
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-lg">
              <div className="relative h-64">
                <img 
                  src="/Danube/gallery_img_mobile5.webp" 
                  alt="Sparklz By Danube" 
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Launch Offer
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Sparklz By Danube</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  SPARKLZ by Danube brings modern elegance to the thriving community of Al Furjan. Crafted for contemporary lifestyle, this exceptional development features sleek design, a prime location, and over 30 lifestyle-enhancing amenities to offer an unmatched living experience.
                </p>
                
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="text-center p-4 bg-gray-50 rounded-lg">
                    <div className="text-2xl font-bold text-red-600">AED 900K</div>
                    <div className="text-sm text-gray-600">Starting Price</div>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-lg">
                    <div className="text-2xl font-bold text-red-600">Studio, 1, 2, 3</div>
                    <div className="text-sm text-gray-600">Bedrooms</div>
                  </div>
                </div>
                
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-2">Key Features:</h4>
                  <ul className="text-gray-700 space-y-1">
                    <li>• Fully Furnished Apartments</li>
                    <li>• Post Handover Payment Plan</li>
                    <li>• 6 Years Payment Plan</li>
                    <li>• 1% Monthly with 0% Interest</li>
                  </ul>
                </div>
                
                <button className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors duration-200">
                  Enquire Now
                </button>
              </div>
            </div>

            {/* TIMEZ Project */}
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-lg">
              <div className="relative h-64">
                <img 
                  src="/Danube/gallery_img_mobile6.webp" 
                  alt="TIMEZ by Danube" 
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Flexible Living
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">TIMEZ by Danube</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Step into a world where sophistication meets exceptional living. TIMEZ by Danube offers an exquisite blend of timeless design and modern luxury, creating the perfect space for those who seek both comfort and elegance.
                </p>
                
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="text-center p-4 bg-gray-50 rounded-lg">
                    <div className="text-2xl font-bold text-blue-600">AED 800K</div>
                    <div className="text-sm text-gray-600">Starting Price</div>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-lg">
                    <div className="text-2xl font-bold text-blue-600">Studio, 1, 2, 3</div>
                    <div className="text-sm text-gray-600">Bedrooms</div>
                  </div>
                </div>
                
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-2">Unique Features:</h4>
                  <ul className="text-gray-700 space-y-1">
                    <li>• Convertible Apartments</li>
                    <li>• Studios to 1 BHKs</li>
                    <li>• 1 BHKs to 2 BHKs</li>
                    <li>• Flexible Living Spaces</li>
                  </ul>
                </div>
                
                <button className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200">
                  Enquire Now
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Why Invest in Dubai Section */}
        <section className="bg-gray-50 py-20">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" style={{fontFamily: 'Roboto, sans-serif'}}>Why Invest in Dubai?</h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="text-center p-6 bg-white rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Fastest Growing Economy</h3>
                <p className="text-gray-700">Dubai's dynamic economy offers excellent investment opportunities with consistent growth.</p>
              </div>
              
              <div className="text-center p-6 bg-white rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Tax Free 100% Income</h3>
                <p className="text-gray-700">Enjoy tax-free income and capital gains on your property investments.</p>
              </div>
              
              <div className="text-center p-6 bg-white rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">High Capital Appreciation</h3>
                <p className="text-gray-700">Strong property value growth with excellent ROI potential.</p>
              </div>
              
              <div className="text-center p-6 bg-white rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Long-Term Golden Visa</h3>
                <p className="text-gray-700">Eligible for long-term residency with property investment.</p>
              </div>
              
              <div className="text-center p-6 bg-white rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Freehold Ownership</h3>
                <p className="text-gray-700">100% freehold ownership rights for international investors.</p>
              </div>
              
              <div className="text-center p-6 bg-white rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Worldwide Connectivity</h3>
                <p className="text-gray-700">Excellent global connectivity with major international hubs.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section className="max-w-6xl mx-auto py-20 px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" style={{fontFamily: 'Roboto, sans-serif'}}>Gallery</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="relative group overflow-hidden rounded-lg">
              <img src="/Danube/5.jpg" alt="Danube Project" className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            </div>
            <div className="relative group overflow-hidden rounded-lg">
              <img src="/Danube/6.jpg" alt="Danube Project" className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            </div>
            <div className="relative group overflow-hidden rounded-lg">
              <img src="/Danube/7.jpg" alt="Danube Project" className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            </div>
            <div className="relative group overflow-hidden rounded-lg">
              <img src="/Danube/8.jpg" alt="Danube Project" className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            </div>
            <div className="relative group overflow-hidden rounded-lg">
              <img src="/Danube/9.jpg" alt="Danube Project" className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            </div>
            <div className="relative group overflow-hidden rounded-lg">
              <img src="/Danube/10.jpg" alt="Danube Project" className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            </div>
          </div>
        </section>

        {/* Amenities Section */}
        <section className="bg-gray-50 py-20">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" style={{fontFamily: 'Roboto, sans-serif'}}>Amenities</h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {/* Sparklz Amenities */}
              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">Sparklz Amenities</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-red-600 rounded-full"></div>
                    <span className="text-gray-700">Central Park</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-red-600 rounded-full"></div>
                    <span className="text-gray-700">Al Ain - Dubai Road</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-red-600 rounded-full"></div>
                    <span className="text-gray-700">Sheikh Mohammed Bin Zayed Road</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-red-600 rounded-full"></div>
                    <span className="text-gray-700">Silicon Central Mall</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-red-600 rounded-full"></div>
                    <span className="text-gray-700">Proposed Metro Station</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-red-600 rounded-full"></div>
                    <span className="text-gray-700">DSO Lake</span>
                  </div>
                </div>
              </div>

              {/* TIMEZ Amenities */}
              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">TIMEZ Amenities</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                    <span className="text-gray-700">Gardens Metro</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                    <span className="text-gray-700">The Palm Jumeirah</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                    <span className="text-gray-700">Global Village</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                    <span className="text-gray-700">Ibn Battuta Mall</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                    <span className="text-gray-700">Expo City</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                    <span className="text-gray-700">Burj Khalifa</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Invest with Danube Section */}
        <section className="max-w-6xl mx-auto py-20 px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" style={{fontFamily: 'Roboto, sans-serif'}}>Why invest with DANUBE PROPERTIES?</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">0%</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Zero Interest</h3>
              <p className="text-gray-700">Attractive payment plans with zero interest options</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">1%</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Pay 1% Per Month</h3>
              <p className="text-gray-700">Flexible monthly payment structure</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">72</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Months Payment Plan</h3>
              <p className="text-gray-700">Extended payment period for convenience</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">High Return on Investment</h3>
              <p className="text-gray-700">Excellent ROI potential with strategic locations</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Timely Delivery</h3>
              <p className="text-gray-700">Reliable project completion timelines</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Prime Location</h3>
              <p className="text-gray-700">Strategic locations with excellent connectivity</p>
            </div>
          </div>
        </section>

        {/* Registration Form */}
        <section className="max-w-4xl mx-auto py-20 px-4">
          <div className="bg-white border border-gray-200 rounded-lg p-8">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-light text-gray-900 mb-4" style={{fontFamily: 'Roboto, sans-serif'}}>Enquire Now</h2>
              <p className="text-lg text-gray-700">Get in touch with us for more information</p>
            </div>
            
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <input type="text" placeholder="Name" className="px-4 py-3 border border-gray-300 bg-white text-gray-900 focus:outline-none focus:border-black" />
                <input type="email" placeholder="Email" className="px-4 py-3 border border-gray-300 bg-white text-gray-900 focus:outline-none focus:border-black" />
              </div>
              <input type="tel" placeholder="Phone" className="px-4 py-3 border border-gray-300 bg-white text-gray-900 focus:outline-none focus:border-black" />
              <select className="px-4 py-3 border border-gray-300 bg-white text-gray-900 focus:outline-none focus:border-black">
                <option value="">Country</option>
                <option value="uae">UAE</option>
                <option value="india">India</option>
                <option value="uk">UK</option>
                <option value="usa">USA</option>
                <option value="canada">Canada</option>
                <option value="other">Other</option>
              </select>
              <select className="px-4 py-3 border border-gray-300 bg-white text-gray-900 focus:outline-none focus:border-black">
                <option value="">Province</option>
                <option value="dubai">Dubai</option>
                <option value="abu-dhabi">Abu Dhabi</option>
                <option value="sharjah">Sharjah</option>
                <option value="other">Other</option>
              </select>
              <select className="px-4 py-3 border border-gray-300 bg-white text-gray-900 focus:outline-none focus:border-black">
                <option value="">Which project are you interested in?</option>
                <option value="sparklz">Sparklz</option>
                <option value="timez">TIMEZ</option>
              </select>
              <div className="mt-6">
                <label className="flex items-start space-x-2 text-sm text-gray-700">
                  <input type="checkbox" className="mt-1" required />
                  <span>By accepting and providing my personal information I am consenting to Danube Properties Privacy Policy, as well as the applicable data protection laws.*</span>
                </label>
              </div>
              <button type="submit" className="w-full mt-8 px-6 py-3 bg-red-600 text-white font-semibold hover:bg-red-700 transition-colors duration-200">SUBMIT</button>
            </form>
            
            <div className="mt-8 p-4 bg-gray-50 rounded-lg">
              <p className="text-xs text-gray-600">
                <strong>Disclaimer:</strong> We are an authorized marketing partner for Danube Properties. Provided content is given by respective owners and this website/landing page and content is for information purpose only and it does not constitute any offer to avail for any services. Prices mentioned are subject to change without prior notice and properties mentioned are subject to availability. You can expect a call, SMS or emails on details registered with us.
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="max-w-4xl mx-auto mb-20 px-4">
          <h2 className="text-2xl md:text-3xl font-light text-gray-900 mb-8 text-center" style={{fontFamily: 'Roboto, sans-serif'}}>Frequently Asked Questions</h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                <button 
                  className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors duration-200 flex justify-between items-center"
                  onClick={() => {
                    const faqElement = document.getElementById(`faq-${index}`);
                    if (faqElement) {
                      faqElement.classList.toggle('hidden');
                    }
                  }}
                >
                  <h3 className="text-lg font-semibold text-gray-900">{faq.q}</h3>
                  <svg className="w-5 h-5 text-gray-500 transform transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div id={`faq-${index}`} className="hidden px-6 py-4 border-t border-gray-200">
                  <p className="text-gray-700 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
} 